export var TrackingType;
(function (TrackingType) {
    TrackingType["START"] = "START";
    TrackingType["PAUSE"] = "PAUSE";
    TrackingType["SKIP"] = "SKIP";
    TrackingType["COMPLETE"] = "COMPLETE";
})(TrackingType || (TrackingType = {}));
//# sourceMappingURL=tracking-type.enum.js.map